<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="row" fxFill>
  <div class="detail" fxFlex>
    <router-outlet></router-outlet>
  </div>
</div>
